import { render, staticRenderFns } from "./MyAssetsPage.vue?vue&type=template&id=34f050c0&scoped=true&"
import script from "./MyAssetsPage.vue?vue&type=script&lang=ts&"
export * from "./MyAssetsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyAssetsPage.vue?vue&type=style&index=0&id=34f050c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f050c0",
  null
  
)

export default component.exports